import { readAllData, STORES } from "utility"

export async function getMedicinesOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.MEDICINE)

  if (filters.titled) {
    data = data.filter((m) =>
      m.titled?.toLowerCase().includes(filters.titled.toLowerCase()),
    )
  }

  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
